var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.4 2.4h1.2v1.23c3.033.3 5.4 2.858 5.4 5.97v3.653l2.223 2.224.177.176V18H3.6v-2.347l.176-.176L6 13.253V9.6a5.997 5.997 0 0 1 5.4-5.97zm.6 2.4a4.8 4.8 0 0 0-4.8 4.8v4.148l-.177.176L4.8 16.148v.652h14.4v-.652l-2.224-2.224-.176-.176V9.6A4.8 4.8 0 0 0 12 4.8M9.6 19.2h1.2a1.199 1.199 0 1 0 2.4 0h1.2c0 1.324-1.077 2.4-2.4 2.4a2.4 2.4 0 0 1-2.4-2.4"
  })));
};
export default SvgBell;